import FormNumberInput from '@/components/UI/FormNumberInput';
import type { OptimizerValidationSettings } from './jobConfigInput';

const fields: {
    key: keyof OptimizerValidationSettings;
    label: string;
    helpText: string;
    min: number;
    max?: number;
    scale: number;
    suffix: string;
    integer?: boolean;
}[] = [
    {
        key: 'minCoverage',
        label: 'Minimum signals retained',
        helpText: 'Reject rules that keep less than this share of signals.',
        min: 0.1,
        max: 100,
        scale: 100,
        suffix: '%'
    },
    {
        key: 'featureMissingRateMax',
        label: 'Maximum missing feature data',
        helpText: 'Exclude features missing more than this share of values.',
        min: 0,
        max: 100,
        scale: 100,
        suffix: '%'
    },
    {
        key: 'holdoutFraction',
        label: 'Held-out data',
        helpText: 'Reserve this share for validation, not rule discovery.',
        min: 0,
        max: 50,
        scale: 100,
        suffix: '%'
    },
    {
        key: 'embargoSeconds',
        label: 'Validation time gap',
        helpText: 'Gap between training and validation. Seven days = 604800 seconds.',
        min: 0,
        scale: 1,
        suffix: 'sec',
        integer: true
    },
    {
        key: 'winsorPercentile',
        label: 'Outlier clipping percentile',
        helpText: 'Limit extreme returns at this percentile when scoring rules.',
        min: 50,
        max: 100,
        scale: 100,
        suffix: '%'
    },
    {
        key: 'winsorMaxCap',
        label: 'Scored return cap',
        helpText: 'Maximum return used in scoring, in percentage points; does not change trade exits.',
        min: 1,
        max: 10000,
        scale: 1,
        suffix: '%'
    }
];

export default function ValidationConfigFields({
    value,
    onChange
}: {
    value: OptimizerValidationSettings;
    onChange: (value: OptimizerValidationSettings) => void;
}) {
    return (
        <>
            <p className="col-span-full text-sm text-zinc-400">
                Optional validation settings. Leave blank to use the server default. Closing Config keeps your settings.
            </p>
            {fields.map((field) => {
                const current = value[field.key];
                return (
                    <FormNumberInput
                        key={field.key}
                        id={`opt-${field.key}`}
                        label={field.label}
                        helpText={field.helpText}
                        min={field.min}
                        max={field.max}
                        integer={field.integer}
                        step={field.integer ? 1 : 0.1}
                        suffix={field.suffix}
                        placeholder="Server default"
                        value={current === undefined ? null : current * field.scale}
                        onValueChange={(next) => onChange({ ...value, [field.key]: next === null ? undefined : next / field.scale })}
                    />
                );
            })}
        </>
    );
}
